import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Alert } from 'src/app/model/Alert';
import { OneViewClientOpportunityViewModelWrapper } from 'src/app/model/Client/CreateClientViewModel';
import { EngagementDialogTitles } from 'src/app/model/Engagement/Engagements';
import { SecondarySolutionCode } from 'src/app/model/Engagement/SecondarySolutionCodes';
import { AssignmentOpportunityModel } from 'src/app/model/HDWorkItemModel';
import { InitiateEngagementComponent } from 'src/app/pages/initiate-engagement/initiate-engagement.component';
import { AlertsService } from 'src/app/services/alerts.service';
import { LoadingScreenService } from 'src/app/services/loading-screen.service';
declare var $;

@Component({
  selector: 'app-assignment-opportunity-popup',
  templateUrl: './assignment-opportunity-popup.component.html',
  styleUrls: ['./assignment-opportunity-popup.component.css']
})
export class AssignmentOpportunityPopupComponent implements OnInit {
@Input() assignmentPopupModel: AssignmentOpportunityModel= new AssignmentOpportunityModel();
@Input() editMode: boolean=false;
@Input() isPageLoadOnInitiatingContinuanceEngagement:boolean;
@Input() secondarySolutionCode: SecondarySolutionCode[] = [];
@Input() opportunityId:string="";
isAnyErrorOnOpportunity:boolean=false;
@Output() checkedMyOpportunityNotListed: EventEmitter<boolean> = new EventEmitter<boolean>();
@Output() OkButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
@Output() opportunityServiceValidationFlag: EventEmitter<boolean> = new EventEmitter<boolean>();
@Output() selectedOpportunityServices: EventEmitter<any[]> = new EventEmitter<any[]>();
isAddAssignmentClicked:boolean=  true;
@Input() oneViewClientOpportunityViewModelWrapper: OneViewClientOpportunityViewModelWrapper = new OneViewClientOpportunityViewModelWrapper();
@Input() isContinuanceEngExistsPopupOpen:boolean=false;
@Input() engopportunityId:string="";
@Input() clientSearchFeatureFlagEnabled:boolean = false;
@Input() opportunityPopupOpenForAddAssignment:boolean
@Output() showInterchangeablePopup = new EventEmitter<any>();
opportunityServiceErrorMessage: string;
@Input() opportunityServiceId:string="";
  alert: Alert;
  opportunityServiceListErrorMessage: string;
  opportunityServiceLinkErrorMessage: string;
  validateOpportunityService: boolean = false;
  constructor(private _alertService: AlertsService, private loadingScreenService: LoadingScreenService)
  {

  }

ngOnInit() {
console.log("assignmentPopupModel-data" + this.assignmentPopupModel.clientOpportunityList);
}
CancelOpportunityPopUp(){
  this.validateOpportunityService = false;
  $("#assignment-opportunity-popup").modal('hide');

}

 onAssignmentOpportunityServiceClick(opportunityId: string, opportunityServiceId: string, isChecked: boolean, row: number, col: number, showPopup: boolean) {
    this.opportunityServiceErrorMessage = "";
    this.opportunityServiceListErrorMessage = "";
    this.opportunityServiceLinkErrorMessage = "";
    //Interchangeable solutioncode confirmation popup
    if (this.assignmentPopupModel.clientOpportunityList?.find(i => i.opportunityId == opportunityId).
      opportunityServiceList.find(s => s.opportunityServiceId == opportunityServiceId).interchangeableSolutionCodeFlag
      && showPopup && !isChecked) {
      this.opportunityId = opportunityId;
      this.opportunityServiceId = opportunityServiceId;
      // this.initiateEngagementComponent.setDialogContent("information", EngagementDialogTitles.InterChangeableSolutionCodes);
      this.showInterchangeablePopup.emit({
        opportunityId: opportunityId,
        opportunityServiceId: opportunityServiceId
      });
      return;

    }

    //check/uncheck selected service
    // this.assignmentPopupModel.clientOpportunityList?.find(o => o.opportunityId == opportunityId).
    //   opportunityServiceList.find(s => s.opportunityServiceId == opportunityServiceId).isChecked = !isChecked;

    //unselect isOpportunityServicelisted check box if anyone opportunityService selected
    if (this.assignmentPopupModel.clientOpportunityList?.find(o => o.opportunityId == opportunityId).
      opportunityServiceList.find(s => s.opportunityServiceId == opportunityServiceId).isChecked) {
      this.oneViewClientOpportunityViewModelWrapper.isOpportunityServicelisted = false;
    }
    if (this.engopportunityId != '' || this.engopportunityId != undefined) {
      let isEnabledVar = false;
      this.assignmentPopupModel.clientOpportunityList?.filter(o => o.opportunityId == opportunityId).forEach(oopElement => {
        oopElement.opportunityServiceList.forEach(os => {
          if (!os.isPrimary && this.oneViewClientOpportunityViewModelWrapper.isOpportunityServiceMatchWithPrimary) {
            if (this.secondarySolutionCode.find(item => item.solutionCode == os.solutionCode) != undefined) {
              var primaryServiceSelectedCount = oopElement.opportunityServiceList.filter(x => (x.isPrimary || x.interchangeableSolutionCodeFlag) && x.isChecked).length;
              if (os.isChecked) {
                os.isChecked = (primaryServiceSelectedCount > 0 || this.opportunityPopupOpenForAddAssignment) ? true : false;
              }
              ///This is to enable/disable check box for selected service
              isEnabledVar = os.isEnabled;
              os.isEnabled = (primaryServiceSelectedCount > 0 || os.interchangeableSolutionCodeFlag || this.opportunityPopupOpenForAddAssignment) ? true : false;
            }
          }
          console.log('Enabled Value: ', isEnabledVar);
          var isSelectedServicePrimary = oopElement.opportunityServiceList.filter(x => (x.isPrimary || x.interchangeableSolutionCodeFlag) && x.opportunityServiceId == opportunityServiceId).length;
          if (isSelectedServicePrimary > 0 && os.opportunityServiceId != opportunityServiceId && !this.opportunityPopupOpenForAddAssignment) {
            os.isChecked = false;
          }
        }
        )
      });

      //Allow selection from multiple opportunities - commented out the code that unchecks services from other opportunities
      // let exceptSelectedclientOpportunityList = this.assignmentPopupModel.clientOpportunityList?.filter(e => e.opportunityId != opportunityId);
      // exceptSelectedclientOpportunityList.forEach(oopElement => {
      //   oopElement.opportunityServiceList.forEach(e => {
      //     e.isChecked = false;
      //     if ((!e.isPrimary && !e.interchangeableSolutionCodeFlag) && this.oneViewClientOpportunityViewModelWrapper.isOpportunityServiceMatchWithPrimary) {
      //       e.isEnabled = false;
      //     }
      //   }
      //   )
      // });
      this.selectedOpportunityServices.emit(this.assignmentPopupModel.clientOpportunityList);
    }
    console.log('clientOpportunityList after check click==>', this.assignmentPopupModel.clientOpportunityList);
  }

OpportunityServiceNotListed() {
    this.opportunityServiceErrorMessage = '';
    this.opportunityServiceListErrorMessage = '';
    let value = this.oneViewClientOpportunityViewModelWrapper.isOpportunityServicelisted;
    //unselect if any opportunityService selected
    this.assignmentPopupModel.clientOpportunityList?.forEach(oopElement => {
      oopElement.opportunityServiceList.forEach(e => {
        if (e.isChecked) {
          e.isChecked = false;
        }
        if (this.engopportunityId == undefined) {
          if (!e.isPrimary && this.oneViewClientOpportunityViewModelWrapper.isOpportunityServiceMatchWithPrimary) {
            e.isEnabled = false;
          }
        }
      }
      )
    });
    this.checkedMyOpportunityNotListed.emit(this.oneViewClientOpportunityViewModelWrapper.isOpportunityServicelisted);
}

 CheckOpportunityValidation() {
    this.isAnyErrorOnOpportunity = false;
    if (!this.oneViewClientOpportunityViewModelWrapper.isOpportunityServicelisted) {
      this.validateOpportunityService = true;
      let selecteOpportunity = this.assignmentPopupModel.clientOpportunityList?.find(o => o.opportunityServiceList.find(s => s.isChecked))
      console.log('selecteOpportunity ', selecteOpportunity);

      if (selecteOpportunity == undefined) {
        if (this.clientSearchFeatureFlagEnabled) {
          if (this.isAddAssignmentClicked) {
            this.oneViewClientOpportunityViewModelWrapper.isOpportunitySelected = false;
          }
          else {
            this.oneViewClientOpportunityViewModelWrapper.isOpportunitySelected = true;
          }
        }
        else {
          this.oneViewClientOpportunityViewModelWrapper.isOpportunitySelected = true;
        }

        $("#assignment-opportunity-popup").modal('show');
        this.isAnyErrorOnOpportunity= true;
        this.opportunityServiceValidationFlag.emit(true);
        return;
        
        // if (this.isPageLoadOnInitiatingContinuanceEngagement) {
        //   //Dont show error message in popup when continunce engagement is initiated and we show popup in edit engagement screen for first time.
        //   this.validateOpportunityService = false;
        //   return true;
        // }
        // else {
        // }
        
      } else {
        this.validateOpportunityService = false;
        return true;
      }
    } else {
      this.validateOpportunityService = false;
      return true;
    }
  }

OkOpportunityPopUp() {
    this.opportunityServiceErrorMessage = "Please select opportunity service.";
    this.opportunityServiceLinkErrorMessage = "Select a primary solution code opportunity service in order to continue.";
    this._alertService.remove(this.alert);
    if (this.CheckOpportunityValidation()) {
    }
    if(!this.isAnyErrorOnOpportunity) {
      this.OkButtonClicked.emit(true);
    }
   }
  trackByService(index: number, item: any): number {
  return item.opportunityServiceId;
  }
  }
